<template>
  <transition name="modal">
    <div class="modal-mask popup">
      <div class="modal-wrapper">
        <div class="modal-container">
          <template v-if="showModalClose">
            <i class="icon icon-close" @click="$emit('close')"></i>
          </template>

          <div class="modal-header">
            <slot name="header"> </slot>
          </div>

          <div class="modal-body">
            <slot name="body"> </slot>
          </div>

          <div
            class="modal-footer"
            :class="{
              'modal-footer--left': footerAlign === 'left',
              'modal-footer--right': footerAlign === 'right'
            }"
          >
            <slot name="footer">
              <vbutton class="button-ok" label="common.ok" @click="$emit('close')" />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'Popup',

    props: {
      visible: Boolean,

      showModalClose: {
        type: Boolean,
        default: true
      },

      footerAlign: {
        type: String,
        default: 'center'
      }
    },

    created() {
      document.getElementsByTagName('html')[0].className = 'modalIsOpened';
    },

    beforeDestroy() {
      document.getElementsByTagName('html')[0].className = '';
    }
  };
</script>

<style lang="scss" scoped>
.modal-footer,
.modal-header,
.modal-body {
  width: 100%;
}
.button-ok {
  min-width: 100px;
}
.modal-wrapper .icon-close {
  position: absolute;
  top: 15px;
  right: 15px;
  color: $main-dark;
  cursor: pointer;
  font-size: 20px;
  transition: color 0.3s;

  &:hover {
    color: $green-hover;
    transition: color 0.3s;
  }
}
</style>
